import React from 'react'

function ModalSelectBox({ handleSelect = () => { }, name, values, classnames = "", icon = "ri-code-line", style = {} }) {
  return (
    <div
      onClick={handleSelect}
      role='button'
      className={
        'd-flex align-items-center px-3 py-2 border rounded bg-light ' + classnames}
      style={style}
    >
      <i className={`${icon} fs-16 me-3`}></i>
      <p className='m-0 user-select-none me-3'>{name}</p>
      <p className='text-muted text-truncate user-select-none m-0'>
        {values}
      </p>
    </div>
  )
}

export default ModalSelectBox;